/**
 * FT13-U28: sub-ledger to General Ledger reconciliation (FSD 2.2.8, V02, AC02).
 * Spread by INT into the router; no module entitlement, like every close route.
 */

import type { RouteRecordRaw } from 'vue-router'

import { RECON_PERMISSIONS } from '@/modules/close/reconciliation/api'

export const CLOSE_RECONCILIATION_ROUTES: RouteRecordRaw[] = [
  {
    path: '/close/reconciliation',
    name: 'close-reconciliation',
    component: () => import('@/modules/close/reconciliation/ReconciliationView.vue'),
    meta: { titleKey: 'close.ft13.routeTitles.reconciliation', permission: RECON_PERMISSIONS.read },
  },
]
